// extracted by mini-css-extract-plugin
module.exports = {"container":"XP-z","links":"YP-z"};